import { CommitmentActivity } from "features/commitments/CommitmentActivity";
import { CommitmentTabProps } from "features/commitments/view/tabs/CommitmentTabProps";
import React from "react";
import { useOutletContext } from "react-router-dom";

export const CommitmentTabActivity: React.FC = () => {
  const { fundFamilyId, investorId, investorEntityId, commitmentId } =
    useOutletContext<CommitmentTabProps>();
  return (
    <CommitmentActivity
      fundFamilyId={fundFamilyId}
      investorId={investorId}
      investorEntityId={investorEntityId}
      commitmentId={commitmentId}
    />
  );
};
